export default "__VITE_ASSET__HAMKlWq5__"